
import { AppProviders } from "@/components/providers/AppProviders";
import AppRoutes from "@/routes/AppRoutes";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ThemeProvider } from "@/components/ui/theme-provider";
import { Suspense } from "react";
import "@/lib/i18n"; // Inicializar i18n

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider 
        attribute="class"
        defaultTheme="system" 
        enableSystem
        disableTransitionOnChange
      >
        <AppProviders>
          <Suspense fallback={
            <div className="min-h-screen flex items-center justify-center">
              <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
                <p>Loading...</p>
              </div>
            </div>
          }>
            <AppRoutes />
          </Suspense>
        </AppProviders>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
